import React from "react";

interface IOrderPaymentCodeProps {
  paymentCode: string;
  paymentNote: string;
}

const OrderPaymentCode = (props: IOrderPaymentCodeProps) => {
  const { paymentCode, paymentNote } = props;

  return (
    <div className="order-detail-row message-payment-transfer">
      <div className="order-detail-row">
        <span>{paymentNote}</span>
      </div>
      <div className="order-detail-row">
        <span>{paymentCode}</span>
      </div>
    </div>
  );
};

export default OrderPaymentCode;
